import React from 'react'
import { Box, Container, Group, Text, Anchor, Image, Stack, SimpleGrid, Flex } from '@mantine/core'
import classes from './Footer.module.css'
import etfNexusLogoLight from '@/assets/img/logo_light.png'
import { ReactComponent as IcXTwitter } from '@/assets/icon/ic_x_twitter.svg.svg'
import { ReactComponent as IcLinkedin } from '@/assets/icon/ic_linkedin.svg'
import { ReactComponent as IcFacebook } from '@/assets/icon/ic_facebook.svg'
import { ReactComponent as IcYoutube } from '@/assets/icon/ic_youtube.svg'
import { ReactComponent as IcInstagram } from '@/assets/icon/ic_instagram.svg'
import { ReactComponent as IcReddit } from '@/assets/icon/ic_reddit.svg'
import { LAYOUT_CONSTANTS } from '@/constants/styles'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <Box className={classes.footer} bg="blue.7" w="100%">
      <Container fluid py="lg">
        <Box w={{ base: '100%', xl: `${LAYOUT_CONSTANTS.CONTENT_AREA_WIDTH}px` }} py={{ base: 'xl', lg: '3xl' }} px="lg" style={{ margin: '0 auto' }}>
          {/* Main footer content */}
          <Group align="flex-start" justify="space-between" w="100%">
            <Stack gap="md" maw={350}>
              <Box style={{ alignSelf: 'flex-start' }}>
                <Image src={etfNexusLogoLight} alt="ETF NEXUS" />
              </Box>
              <Text size="xs" c="white">
                The best way to compare ETFs and find the right one for you.
              </Text>
            </Stack>

            <SimpleGrid cols={{ base: 2, lg: 3 }} spacing={80}>
              <Stack gap="md" hiddenFrom="base" visibleFrom="lg">
                {' '}
                {/*Spacer*/}
              </Stack>

              <Stack gap="md">
                <Text fw={700} size="lg" className={classes.title}>
                  About
                </Text>
                <Stack gap="sm">
                  <Anchor className={classes.link} href="/about/about-us">
                    About us
                  </Anchor>
                  <Anchor className={classes.link} href="/about/editorial-policy">
                    Editorial policy
                  </Anchor>
                  <Anchor className={classes.link} href="/about/privacy-policy">
                    Privacy policy
                  </Anchor>
                  <Anchor className={classes.link} href="/about/terms-of-use">
                    Terms of use
                  </Anchor>
                  <Anchor className={classes.link} href="/about/disclaimer">
                    Disclaimer
                  </Anchor>
                  <Anchor className={classes.link} href="/about/cookie-policy">
                    Cookie policy
                  </Anchor>
                  <Anchor
                    href="#"
                    className={`${classes.link} termly-display-preferences`}
                    onClick={(e) => e.preventDefault()}>
                    Cookie settings
                  </Anchor>
                </Stack>
              </Stack>

              <Stack gap="md">
                <Text fw={700} size="lg" className={classes.title}>
                  Assistance
                </Text>
                <Stack gap="sm">
                  <Anchor className={classes.link} href="/assistance/contact">
                    Contact us
                  </Anchor>
                  <Anchor className={classes.link} href="/assistance/faq">
                    FAQ
                  </Anchor>
                </Stack>
              </Stack>
            </SimpleGrid>
          </Group>

          {/* Footer bottom section */}
          <Flex direction={{ base: 'column', md: 'row' }} justify={'space-between'} w="100%" mt={{ base: 'xl', md: '3xl' }} gap={{ base: 'md', md: 0 }}>
            <Text c="white" size="sm">
              @ {currentYear} ETF Nexus. All rights reserved.
            </Text>
            <Group gap={24} w="auto">
              <Anchor href="https://x.com/NexusETF" className={classes.socialLink}>
                <IcXTwitter />
              </Anchor>
              <Anchor href="https://www.linkedin.com/company/etf-nexus/" className={classes.socialLink}>
                <IcLinkedin />
              </Anchor>
              <Anchor href="https://www.instagram.com/etf.nexus/" className={classes.socialLink}>
                <IcInstagram />
              </Anchor>
              <Anchor href="https://www.facebook.com/profile.php?id=61576194698086" className={classes.socialLink}>
                <IcFacebook />
              </Anchor>
              <Anchor href="https://www.reddit.com/user/ETFNexus/" className={classes.socialLinkReddit}>
                <IcReddit />
              </Anchor>
            </Group>
          </Flex>
        </Box>
      </Container>
    </Box>
  )
}

export default Footer
